import { CONTACT } from "@/constants/contact";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-xl font-semibold uppercase">{title}</h2>
    <div className="mt-3 space-y-3 text-sm text-muted-foreground">{children}</div>
  </section>
);

export default function MentionsLegalesPage() {
  return (
    <div data-testid="legal-page" className="mx-auto max-w-3xl px-4 py-20">
      <h1 className="font-display text-4xl font-bold uppercase sm:text-5xl">
        Mentions légales
      </h1>

      <Section title="Éditeur du site">
        <p>
          {CONTACT.name} — Garage automobile
          <br />
          {CONTACT.address}
          <br />
          SIRET : {CONTACT.siret}
          <br />
          Téléphone : {CONTACT.phoneDisplay}
          <br />
          E-mail : {CONTACT.email}
        </p>
      </Section>

      <Section title="Directeur de la publication">
        <p>Le gérant de {CONTACT.name}.</p>
      </Section>

      <Section title="Hébergement">
        <p>
          Ce site est hébergé par Emergent (emergent.sh), plateforme de
          création et d'hébergement de sites web.
        </p>
      </Section>

      <Section title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus du site (textes, logo, éléments graphiques)
          est la propriété de {CONTACT.name}. Toute reproduction, même
          partielle, est interdite sans autorisation préalable.
        </p>
      </Section>

      <Section title="Responsabilité">
        <p>
          Les informations présentées sur ce site (prestations, tarifs) sont
          données à titre indicatif et peuvent évoluer. Pour toute
          confirmation, contactez le garage au {CONTACT.phoneDisplay}.
        </p>
      </Section>
    </div>
  );
}
